import React from 'react';
import PropTypes from 'prop-types';
import HorizontalBarChart from './HorizontalBarChart';

const CarrerasChart = ({ data, period }) => {
  return (
    <HorizontalBarChart
      data={{
        ...data,
        datasetLabel: 'Número de Atenciones'
      }}
      period={period}
      title="Atenciones por Carrera"
      topLabel="Top"
      allLabel="Todas las carreras"
      tooltipSuffix=" atenciones"
      defaultTopCount={5}
      noDataIcon="bi-graph-up"
      noDataMessage="No hay datos disponibles para el período seleccionado"
      useConsistentColors={false}
      minHeight={300}
      barHeight={70}
    />
  );
};

CarrerasChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  period: PropTypes.string.isRequired,
};

export default CarrerasChart;
